import React from "react";
import {
  Container,
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Button,
} from "@mui/material";
import { useLocation } from "react-router-dom";

const AddProductForm = () => {
    const location=useLocation()
const name = location?.state
  return (
    <Container>
      <Typography variant="h2" color="primary" className="text-center" my={2}>
       {name } product
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField label="Product Type" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Title" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Product Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Image 1"
            variant="outlined"
            fullWidth
            type="file"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">📷</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Image 2"
            variant="outlined"
            fullWidth
            type="file"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">📷</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Image 3"
            variant="outlined"
            fullWidth
            type="file"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">📷</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Typography variant="h6" mt={3} mb={2}>
        Vehicle Info
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField label="Average Impressions" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Dimensions" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Sold By" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Fuel Type" variant="outlined" fullWidth />
        </Grid>
      </Grid>

      <Typography variant="h6" mt={3} mb={2}>
        Vehicle KPIs
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField label="Best Uses" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Local Drivers" variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Routes" variant="outlined" fullWidth />
        </Grid>
      </Grid>

      <Typography variant="h6" mt={3} mb={2}>
        Drive Time
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            label="Day Start Time"
            variant="outlined"
            fullWidth
            type="number"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Day End Time"
            variant="outlined"
            fullWidth
            type="number"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Weeks" variant="outlined" fullWidth type="number" />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Months"
            variant="outlined"
            fullWidth
            type="number"
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="center" mt={3}>
        <Button variant="contained" color="primary">
          Submit
        </Button>
      </Grid>
    </Container>
  );
};

export default AddProductForm;
